import { createSelector } from '@reduxjs/toolkit';
import { pick, pickBy } from 'ramda';

import { selectExportEntireDaysExcelError } from '../dashboard/selectors';
import { selectDisplayableGuestErrors } from '../guest/selectors';
import { selectDeliveryError, selectOrderError } from '../order/selectors';
import { selectLookupLocationError } from '../user/selectors';
import { diagnosticMessageAdapter, initialState } from './reducer';
import { mapErrorsToDiagnosticMessages } from './utils';

export const selectDiagnosticMessages = (state: { diagnosticMessages: typeof initialState }) =>
  state.diagnosticMessages;

export const { selectAll: selectAllDiagnosticMessages } =
  diagnosticMessageAdapter.getSelectors(selectDiagnosticMessages);

export const selectDisplayableMessages = createSelector(
  selectOrderError,
  selectDeliveryError,
  selectDisplayableGuestErrors,
  selectExportEntireDaysExcelError,
  selectLookupLocationError,
  selectAllDiagnosticMessages,
  (orderError, deliveryError, guestErrors, excelError, lookupLocationError, diagnosticMessages) => {
    const orderSpecificErrors = pick<typeof orderError, keyof typeof orderError>(
      ['updateOrder', 'editOrder'],
      orderError,
    );
    const deliveryErrorMessage =
      deliveryError && typeof deliveryError === 'object'
        ? `${deliveryError.type}: ${deliveryError.message}`
        : null;
    const errors = {
      ...orderSpecificErrors,
      deliveryErrorMessage,
      ...guestErrors,
      excelError: excelError || null,
      lookupLocationError,
    };

    const errStrings = pickBy<typeof errors, Record<string, string>>(
      (val) => typeof val === 'string' && val !== 'SyntaxError: Unexpected end of JSON input',
      errors,
    );

    return diagnosticMessages.concat(mapErrorsToDiagnosticMessages(errStrings));
  },
);
